<template>
  <div>
    <ul class="flex items-center">
      <li class="leading-none mr-3 xl:mr-4">
        <router-link to="/" class="hover:text-4y-sky-blue">
          {{ tr('common.home') }}
        </router-link>
      </li>
      <li class="leading-none font-bold text-4y-sky-blue">
        <span class="mr-2">
          >
        </span>
        <span>{{ title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Breadcrumb from '~components/shared/breadcrumb.js'

export default Breadcrumb.extend()
</script>
